import cookie from 'js-cookie'
import buildAdParams from './build-ad-params'

/**
 * Prepares a video object with ad parameters for loading into the player.
 * @param {Object} params
 * @param {Object} params.player - The Brightcove player instance
 * @param {Object} params.video - The video object from Brightcove's catalog
 * @param {Object} params.content - The content object with episode information
 * @param {Object} params.videoData - Additional video metadata
 * @param {number} params.resumePosition - Position to resume playback from
 * @returns {Object} The prepared video object with ad parameters
 */
const prepareVideoWithAds = ({
  player,
  video,
  content,
  videoData,
  resumePosition = 0,
}) => {
  const videoObject = player.catalog.transformVideoResponse(video)

  // Get the visitor ID for vcid
  const vcid = cookie.get('STV_USERID')
  const region = window?.parent?.digitalData.user.broadcastRegion
  const userId = cookie.get('STV_USERID')

  // Build the csid based on player type and region
  let csid = 'STV_PlayerWeb'
  if (videoData.isPlayerPlus) {
    csid = csid.concat('_SVOD')
  } else if (region) {
    csid = csid.concat(`_VOD_${region}`)
  } else {
    csid = csid.concat('_VOD')
  }

  // Generate vprn and pvrn IDs
  const vprn = Number(Math.floor(Math.random() * 10000000000000000))
  const pvrn = Number(
    cookie.get('STV_PVRN') || Math.floor(Math.random() * 10000000000000000)
  )
  cookie.set('STV_PVRN', pvrn)

  // Build ad parameters
  const paramsString = buildAdParams({
    content,
    videoData: {
      ...videoData,
      resumePosition,
    },
    resumePosition,
    userId,
    vcid,
    csid,
    vprn,
    pvrn,
  })

  // Apply ad parameters to video sources
  videoObject.sources.forEach((source) => {
    if (!source?.vmap) return
    // eslint-disable-next-line no-param-reassign
    source.vmap = `${source.vmap}&${paramsString}`
  })

  return videoObject
}

export default prepareVideoWithAds
